import React, { useMemo } from 'react';
import CommonVisualInsights from '../CommonVisualInsights';

const RbskVisualInsights = ({ chartData, loading }) => {
    // Overall Totals
    const overallTotals = chartData?.overallTotals || { total_normal: 0, total_mild: 0, total_moderate: 0, total_severe: 0 };

    // Timeline Trend Data
    const timelineSeriesData = useMemo(() => {
        let dates = [], nonList = [], mildList = [], modList = [], sevList = [];
        if (chartData?.timelineTrend) {
            chartData.timelineTrend.forEach((t) => {
                dates.push(t.date);
                nonList.push(t.total_normal || 0);
                mildList.push(t.total_mild || 0);
                modList.push(t.total_moderate || 0);
                sevList.push(t.total_severe || 0);
            });
        }
        return { dates, nonList, mildList, modList, sevList };
    }, [chartData]);

    // District Risk Data
    const districtRiskData = useMemo(() => {
        let categories = [], nonSeries = [], mildSeries = [], moderateSeries = [], severeSeries = [];
        if (chartData?.districtLeaderboard) {
            chartData.districtLeaderboard.forEach((d) => {
                categories.push(d.district_name);
                nonSeries.push(d.total_normal || 0);
                mildSeries.push(d.total_mild || 0);
                moderateSeries.push(d.total_moderate || 0);
                severeSeries.push(d.total_severe || 0);
            });
        }
        return { categories, nonSeries, mildSeries, moderateSeries, severeSeries };
    }, [chartData]);

    const cohortSeriesData = useMemo(() => {
        return {
            categories: ["Children (6 Months -18 Years)"],
            nonData: [overallTotals.total_normal || 0],
            mildData: [overallTotals.total_mild || 0],
            modData: [overallTotals.total_moderate || 0],
            sevData: [overallTotals.total_severe || 0]
        };
    }, [overallTotals]);

    return (
        <CommonVisualInsights
            loading={loading}
            overallTotals={overallTotals}
            cohortSeriesData={cohortSeriesData}
            timelineSeriesData={timelineSeriesData}
            districtRiskData={districtRiskData}
        />
    );
};

export default RbskVisualInsights;
